import type { Slot } from '../types';
import type { LoadResult } from './fileLoad';

export type DistributionResult = {
  nextSlots: Slot[];
  skippedFilenames: string[];
  rejectedFilenames: string[];
  rejectedReasons: Record<string, 'unsupported-type' | 'load-failed'>;
};

export function distributeImages(slots: Slot[], loadResults: LoadResult[]): DistributionResult {
  const successes = loadResults.filter((r): r is Extract<LoadResult, { ok: true }> => r.ok);
  const rejects = loadResults.filter((r): r is Extract<LoadResult, { ok: false }> => !r.ok);

  const nextSlots = slots.map(s => ({ ...s }));
  const queue = [...successes];
  const skippedFilenames: string[] = [];

  for (const slot of nextSlots) {
    if (slot.image !== null) continue;
    const next = queue.shift();
    if (!next) break;
    slot.image = next.image;
  }

  for (const leftover of queue) skippedFilenames.push(leftover.image.filename);

  const rejectedFilenames = rejects.map(r => r.filename);
  const rejectedReasons: Record<string, 'unsupported-type' | 'load-failed'> = {};
  for (const r of rejects) rejectedReasons[r.filename] = r.reason;

  return { nextSlots, skippedFilenames, rejectedFilenames, rejectedReasons };
}
